import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
    selector: 'app-round-voided',
    imports: [CommonModule],
    templateUrl: './round-voided.component.html',
    styleUrl: './round-voided.component.scss'
})
export class RoundVoidedComponent {}
